// extracted by mini-css-extract-plugin
module.exports = {"chip":"SiteFigures_chip__uFYBE","srOnly":"SiteFigures_srOnly__M0Wep"};